<div class="main-container">
  <div class="ui middle aligned center aligned grid">
    <div class="login-container">
      <div class="login-content">
        <h1>Account Login</h1>
        <p class="light">Login into your account here: </p>

        <app-form-error></app-form-error>

        <form class="login">
          <div class="field">
            <div class="label">Email Address</div>
            <app-text-input
              icon="mail"
              type="text"
              v-model="email"
              placeholder="Enter your e-mail address"
              :error="validation('email')"
              tabindex="1"
            />
          </div>

          <div class="field">
            <router-link :to="{name: 'forgotpassword'}"><a class="right floated label primary">Forgotten Password?</a></router-link>
            <div class="left floated label">Password</div>
            <app-text-input
              icon="lock"
              type="password"
              v-model="password"
              placeholder="Enter your password"
              :error="validation('password')"
              autocomplete="current-password"
              @keyup.enter="login"
            />
          </div>

          <div class="field">
            <a class="ui fluid primary button" v-on:click="login">LOGIN</a>
          </div>
        </form>

        <hr>
        <p>Don't have an account? <router-link :to="{name: 'register'}"><a class="primary">Signup Now</a></router-link></p>
      </div>
    </div>
  </div>
</div>
